
/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 * - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
 module.exports = typeof XMLHttpRequest !== 'undefined' &&
 'withCredentials' in new XMLHttpRequest();
} catch (err) {
 // if XMLHttp support is disabled in IE then it will throw
 // when trying to create
 module.exports = false;
}



//////////////////
// WEBPACK FOOTER
// ./~/has-cors/index.js
// module id = 20
// module chunks = 0